<div class="container">
    <app-preloader [percent]="preloaderPercent$ | async" *ngIf="(preloaderPercent$ | async) <= 99"></app-preloader>
    <router-outlet></router-outlet>
    <app-scroll-to-top-button [isMobile]="isMobile"></app-scroll-to-top-button>
</div>
